import React from "react";
import { Link } from "react-router-dom";
import { Bed, Bath, Maximize2 } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

const FALLBACK_IMG =
  "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1200&q=80";

function formatPrice(price, currency = "EUR") {
  const n = Number(price);
  if (!n || Number.isNaN(n)) return "Prijs op aanvraag";
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(n);
}

export default function PropertyCard({ property, index = 0 }) {
  const { t } = useLang();
  const link = `/aanbod/${encodeURIComponent(property.reference)}`;
  const img = property.main_image || FALLBACK_IMG;

  return (
    <Link
      to={link}
      className="group block bg-charcoal-surface border border-white/10 hover:border-gold/40 transition-colors"
      data-testid={`property-card-${property.reference}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="prop-img-wrap aspect-[4/3] bg-charcoal-deep overflow-hidden relative">
        <img
          src={img}
          alt={property.type || "Property"}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = FALLBACK_IMG;
          }}
        />
        <div className="absolute top-3 left-3">
          <span className="overline bg-charcoal-surface/90 px-2 py-1" style={{ fontSize: "0.6rem" }}>
            {property.type}
          </span>
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-baseline justify-between gap-3 mb-1">
          <p className="overline" style={{ fontSize: "0.65rem" }}>
            {property.location || property.area}
          </p>
          <span className="text-[0.65rem] text-cream-subtle">
            {t.properties.viewDetails === "View" ? "REF" : "REF"} {property.reference}
          </span>
        </div>
        <h3 className="font-serif text-2xl text-cream group-hover:text-gold transition-colors leading-tight mb-3">
          {formatPrice(property.price, property.currency)}
        </h3>
        <div className="flex items-center gap-5 text-cream-muted text-xs">
          {property.bedrooms && (
            <span className="flex items-center gap-1.5">
              <Bed size={14} strokeWidth={1.25} />
              {property.bedrooms} {t.properties.bedsLabel}
            </span>
          )}
          {property.bathrooms && (
            <span className="flex items-center gap-1.5">
              <Bath size={14} strokeWidth={1.25} />
              {property.bathrooms} {t.properties.bathsLabel}
            </span>
          )}
          {property.built ? (
            <span className="flex items-center gap-1.5">
              <Maximize2 size={14} strokeWidth={1.25} />
              {property.built} {t.properties.buildLabel}
            </span>
          ) : null}
        </div>
      </div>
    </Link>
  );
}
